module.exports = __webpack_public_path__ + "img/logo-cerveceria-nacional.2e6ecc6c.png";